<template>
	<div class="buy_quantity">
		<div v-wechat-title="$route.meta.title"></div>
		<TopBar></TopBar>
		<div style="display: flex; justify-content: center; flex-direction: column;align-items: center;">
			<div style="width: 85%; height: 50px; background-color: #FFFFFF; margin-top: 20px; display: flex;align-items: center;justify-content: space-between; padding: 0px;">
				<div style="display: flex; align-items: center; justify-content: space-between; width: 120px; ">
					<span>确认订单</span>
					<span style="font-size: 12px;" class="icon iconfont icon-z043"></span>
					<span>付款</span>
				</div>
				<span style="color: #B0A9B0; cursor: pointer;" @click="cancelClick">取消</span>
			</div>
			<!-- 可视区域 -->
			<div class="center">
				<div class="center_box">
					<div style="background-color: #E5F3FF; height: 70px; display: flex; flex-direction: column;justify-content: center;align-items: center;">
						<div style="font-weight: bold;font-size: 20px; color: #000000;">团队版</div>
						<div style="color: #6B79A1;">不限制使用人数</div>
					</div>
					<div style="display: flex; justify-content: center;align-items: center;height: 80px;">
						<span>￥<span style="font-size: 35px;">{{team.team_per_fee}}</span>/人/年</span>
					</div>
					<div style="width: 50px; height: 50px; background-color: #0089FD; transform: rotate(45deg); position: relative; left: 210px; top: -27px;">
						<span style="color: #FFFFFF; position: absolute;top: 15px; left: 5px; transform: rotate(-45deg); font-size: 13px;"
							  class="icon iconfont icon-duihao"></span>
					</div>
				</div>
				<!-- 版本说明 -->
				<div style="margin-top: 40px;">
					<span>团队试用版<span style="font-size: 12px; margin-left: 10px; ">(若您对产品购买存在疑问，可联系客服微信：{{config.service_wx}})</span></span>
					<div style="display: flex;flex-wrap: wrap; margin-top: 60px;">
						<div v-for="(item,index) in teamList" :key="index" style="width: 300px;">
							<span style="font-size: 15px; color: #5AB1FF;" class="icon iconfont icon-duihao"></span>
							<span style="margin-left: 10px; color: #727D8A; white-space: pre;">{{item}}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 底部区域 -->
			<div class="bottom">
				<div style="display: flex; align-items: center; width: 450px; justify-content: space-between;">
					<div style="display: flex; align-items: center;">
						<span>购买名额：</span>
						<div style="position: relative;">
							<Input v-model="theNumber" placeholder="请输入购买名额" style="width: 140px"/>
							<div style="position: absolute; background-color: #FFFFFF; top: 6px;left: 120px; ">人</div>
						</div>
					</div>
					<div style="display: flex; align-items: center;">
						<span>购买期限：</span>
						<div style="width: 100px;height: 30px; border: 1px solid #0089FF; border-radius: 5px; text-align: center; line-height: 30px; overflow: hidden;">
							一年
							<div style="height: 30px; width: 30px; background-color: #0092FF; position: relative; transform: rotate(45deg); top: -15px; left: 85px;">
								<span style="font-size: 10px; position: absolute; left: 0px; top: 0px; transform: rotate(-45deg); color: #FFFFFF;"
									  class="icon iconfont icon-duihao"></span>
							</div>
						</div>
					</div>
				</div>
				<div style="display: flex;align-items: center; width: 260px; justify-content: space-between;">
					<span style="color: #FF696D; font-size: 28px;">￥{{totalSum}}</span>
					<Button style="border-radius: 30px;" @click="save" type="primary">提交订单</Button>
				</div>
			</div>
		</div>
		<Modal v-model="choosePay" width='500' title="支付订单">
			<div>
				<div class="fx-flex"><div>标题：</div><div>{{payItem.ext_info.title}}</div></div>
				<div class="fx-flex"><div>订单号：</div><div>{{payItem.tid}}</div></div>
				<div class="fx-flex"><div>支付金额：</div><div>{{payItem.money}}元</div></div>
				<div class="fx-flex">
					<div>
						支付方式：
					</div>
					<div>
						<RadioGroup v-model="payType">
							<Radio :label="1"><span>支付宝</span></Radio>
							<Radio :label="2"><span>微信</span></Radio>
						</RadioGroup>
					</div>
				</div>
			</div>
			<div slot="footer">
				<Button type="primary" @click="toPay()">确定</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import TopBar from '../topbar/TopBar.vue'
	import {mapGetters} from "vuex";
	import {createOrder,payOrder} from '@/api/order'
	import {getUpgrade} from "../../api/user";
	export default {
		name: "BuyQuantity",
		components: {
			TopBar
		},
		computed:{
			...mapGetters(['token', 'config']),
			totalSum() {
				return this.theNumber * this.team.team_per_fee + '.00'
			}
		},
		data() {
			return {
				team: {},
				teamList: ['日历面板', '团队间任务协作', '律师个人账户管理', '线索拓展系统\n      可联系平台帮助律师获取推广线索', '7*12小时专属技术顾问', '简单易操作的案件管理',
					'易于配置的权限模块', '易上手的财务模块',
				],
				theNumber: 0,
				choosePay: false,
				payItem: {ext_info: {}},
				payType: 1,
			}
		},
		mounted() {
			this.loadData();
		},
		methods:{
			async loadData() {
				let that = this;
				let data = {
					token: that.token,
				};
				let res = await getUpgrade(that, data);
				if (res.code == 1) {
					that.team = res.data.team;
					that.theNumber = that.team.team_nums;
				}
			},
			cancelClick() {
				this.$router.go(-1)
			},
			save() {
				let that = this;
				let data = {token: this.token, number: this.theNumber}
				that.$Modal.confirm({
					title: '确定提交订单吗',
					onOk() {
						that.throttle(async function () {
							var res = await createOrder(that, data);
							if (res.code == 1) {
								that.payItem = res.data.item;
								that.choosePay = true;
							}
						}, 500)
					}
				})

			},
			toPay() {
				let that = this;
				let data = {token: this.token, id: that.payItem.id, payType: that.payType}
				that.throttle(async function () {
					var res = await payOrder(that, data);
					if (res.code == 1) {
						that.choosePay = false;
					}
				}, 500)
			}
		}
	}
</script>

<style scoped lang="less">
	.buy_quantity {
		height: 100%;
		width: 100%;
		background-color: #F5F7F9;
	}

	.center {
		width: 85%;
		height: 450px;
		background-color: #FFFFFF;
		margin-top: 10px;
		padding: 50px;

		.center_box {
			height: 150px;
			width: 240px;
			border: 2px solid #2C9EFF;
			border-radius: 5px;
			overflow: hidden;
		}
	}

	.bottom {
		width: 85%;
		height: 100px;
		background-color: #FFFFFF;
		margin-top: 10px;
		padding: 0 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.fx-flex{
		display: flex;
		justify-content: space-between;
		padding: 5px 0;
	}
</style>
